import _ViewDensityWideIcon from "@adsk/alloy-react-icon/es/lib/ViewDensityWideIcon";
import _ViewDensityStandardIcon from "@adsk/alloy-react-icon/es/lib/ViewDensityStandardIcon";
import _ViewDensityNarrowIcon from "@adsk/alloy-react-icon/es/lib/ViewDensityNarrowIcon";
import _styled, { default as _styled2 } from "styled-components";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import styledC from 'styled-components';
import { useLocale } from '@adsk/alloy-react-locale';
import theme, { stylePropType } from '@adsk/alloy-react-theme';
import DensityOption from './DensityOption';
import { TABLE_SIZES } from '../../consts';
import getTableTheme from '../../helpers/getTableTheme';
const MenuHeading = styledC.div.withConfig({
  displayName: "Density__MenuHeading",
  componentId: "sc-38586l-0"
})(_objectSpread(_objectSpread({}, theme.typography.heading4), {}, {
  color: theme.tokens.colors.text.secondary.value,
  padding: "14px ".concat(theme.spacing.L, "px")
}));
const TableConfigurationDensity = _ref => {
  let {
    label,
    tableSize,
    setSize,
    className,
    style
  } = _ref;
  const tableSizeTheme = getTableTheme(tableSize);
  const {
    T
  } = useLocale(_ref2 => {
    let {
      locale
    } = _ref2;
    return require("../../i18n/".concat(locale, ".json"));
  });
  const densityLabel = T.translate('DENSITY');
  return /*#__PURE__*/React.createElement(_StyledDiv, {
    className: className,
    $_css: [{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center'
    }, style]
  }, /*#__PURE__*/React.createElement(MenuHeading, null, label || densityLabel), /*#__PURE__*/React.createElement(_StyledDiv2, {
    $_css2: [{
      display: 'flex',
      padding: "0 ".concat(theme.spacing.M, "px")
    }]
  }, /*#__PURE__*/React.createElement(DensityOption, {
    setSize: setSize,
    size: TABLE_SIZES.SMALL,
    renderIcon: useCallback(p => /*#__PURE__*/React.createElement(_ViewDensityNarrowIcon, p), []),
    currentSize: tableSizeTheme.size
  }), /*#__PURE__*/React.createElement(DensityOption, {
    setSize: setSize,
    size: TABLE_SIZES.MEDIUM,
    renderIcon: useCallback(p => /*#__PURE__*/React.createElement(_ViewDensityStandardIcon, p), []),
    currentSize: tableSizeTheme.size
  }), /*#__PURE__*/React.createElement(DensityOption, {
    setSize: setSize,
    size: TABLE_SIZES.LARGE,
    renderIcon: useCallback(p => /*#__PURE__*/React.createElement(_ViewDensityWideIcon, p), []),
    currentSize: tableSizeTheme.size
  })));
};
TableConfigurationDensity.propTypes = {
  label: PropTypes.any,
  setSize: PropTypes.func.isRequired,
  style: stylePropType,
  className: PropTypes.string
};
export default TableConfigurationDensity;
var _StyledDiv = styledC("div").withConfig({
  displayName: "Density___StyledDiv",
  componentId: "sc-38586l-1"
})(["", ""], p => p.$_css);
var _StyledDiv2 = styledC("div").withConfig({
  displayName: "Density___StyledDiv2",
  componentId: "sc-38586l-2"
})(["", ""], p => p.$_css2);
//# sourceMappingURL=Density.js.map